import TranscriptSettings from './transcript-settings';
import UploadModal from './upload-modal';
import VideosPage from './VideosPage';
import VideoThumbnail from './VideoThumbnail';
import VideoInfoModalSidebar from './info-sidebar';

export default VideosPage;
export {
  TranscriptSettings,
  UploadModal,
  VideoThumbnail,
  VideoInfoModalSidebar,
};
